export const InvalidDate = 'Una delle date inserite non è nel formato valido! Riprovare'
export const InvalidCurrentPassword = 'La password corrente non è corretta!'
export const InvalidNewPassword = 'La password deve essere almeno di 6 caratteri!'
export const InvalidEmail = 'Questa mail è stata già utilizzata!'
export const InvalidUsername = 'Questo username è stato già utilizzato!'
export const LockedUser = 'Questo utente è stato disabilitato!'

